import { render, staticRenderFns } from "./accedi-come.vue?vue&type=template&id=3182e7bc&"
import script from "./accedi-come.vue.ts?vue&type=script&lang=js&"
export * from "./accedi-come.vue.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports